import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import MrsSangaChakraborty from "../images/Mrs. Sanga Chakraborty.jpg";



function SangaChakraborty() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Headmistress (Primary) <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>Message from the Headmistress (Primary) </b></h1>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-3 mt-3">
                                        <div class="card">
                                            <img src={MrsSangaChakraborty} className="card-img-top" alt="MrsSangaChakraborty" />
                                        </div>

                                    </div>
                                    <div className="col-md-9 mt-3">
                                        <p className='mb-2'>The process of educating a child is one which warrants the involvement of an entire society. The term education, with its roots in the Latin Language, essentially refers to the idea of training or nourishing a child with the ultimate goal of bringing out the best in them. </p>
                                        <p className='justify mb-2'>With the advent of modern theories and practices in the educational sector, the sole aim of schools is to   ensure the all-round development of the child pertaining to the physical, emotional, social and intellectual domains of growth. At Krishnagar Public School, we provide a conducive environment for the child to thrive and learn at the same time. The school’s education system aims to instil confidence, forbearance, empathy along with the 21st century skills of critical thinking, problem-solving, communication, collaboration, and creativity in each and every student. The digital classrooms with access to a wide range of teaching- learning resources, an expansive playground within the school campus which offers opportunities for students to play, explore and engage in various structured physical activities, a state-of-the-art laboratory set up, a well-stocked library, annual educational excursions and field trips – are some of the facilities we provide to all our students.</p>
                                        <p className='justify mb-2'>In order to cater to the demands of the contemporary society as well as to raise culturally and socially aware citizens, we also focus on developing the innate talents of our students with a great emphasis on such art forms as painting, music, drama and dance. The involvement of students in various inter house activities, social awareness drives and annual events enable them to find their true calling.</p>
                                        <p className='justify mb-2'>We believe that our students are our assets. Together with the support and cooperation of the parents and the other stakeholders we are able to equip our children effectively, so that they may achieve their goals and flourish in their future careers. Over the years, the school has witnessed the growth of several such students who have not only established themselves in their field of expertise, but have also contributed significantly to the welfare of the society, thereupon, reinstating that ‘Team KPS’ has always been the wind under their wings. </p>




                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />





                        <div className="d-flex justify-content-end align-items-end mb-0">
                            <div className='teamkps'>
                                <p className='mb-0'>Mrs. Sanga Chakraborty
                                </p>
                                <h5><b>Headmistress (Primary)</b> </h5>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}

export default SangaChakraborty